export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rmc-feedback@2.0.0@rmc-feedback/es/index.js
// module id = 650
// module chunks = 0 1